




































import * as Vue from '@vue/composition-api'
export default Vue.createComponent({
  name: 'YesNoDialog',
  props: {
    msg: String,
    yesCap: {
      type: String,
      default: 'Yes'
    },
    noCap: {
      type: String,
      default: 'No'
    },
    yesIcon: {
      type: String,
      default: 'check'
    },
    noIcon: {
      type: String,
      default: 'close'
    }
  },
  setup (props, ctx) {
    const yes = () => {
      ctx.emit('yes')
    }
    const no = () => {
      ctx.emit('no')
    }

    return {
      yes,
      no
    }
  }
})
